/**
 * Filter Options Constants
 * Defines the available filter categories and default values
 */

export const FILTER_TYPES = {
  CATEGORY: 'calendar_type',
  LOCATION: 'location',
  PRACTICE_AREA: 'practice_area',
  EVENT_TYPE: 'event_type',
  CONFERENCE_ROOM: 'conference_room_id',
  FIRM_SCOPE: 'show_firm_events',
};

export const CATEGORY_OPTIONS = [
  { label: 'Events', value: 'event' },
  { label: 'Tasks', value: 'task' },
  { label: 'Birthdays (DOB)', value: 'user' },
  { label: 'Statute of Limitations (SOL)', value: 'case' },
];

export const DEFAULT_FILTERS = {
  [FILTER_TYPES.CATEGORY]: '',
  [FILTER_TYPES.LOCATION]: '',
  [FILTER_TYPES.PRACTICE_AREA]: '',
  [FILTER_TYPES.EVENT_TYPE]: '',
  [FILTER_TYPES.CONFERENCE_ROOM]: '',
  [FILTER_TYPES.FIRM_SCOPE]: true,
};

// Debounce delay for filter changes (ms)
export const FILTER_DEBOUNCE_DELAY = 300;
